import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        // 全局图片路径
        staticUrl: 'https://image.oskylive.com/360/website/static'
        // staticUrl: 'http://static.com'
    },
    getters: {
    },
    mutations: {
    },
    actions: {
    },
    modules: {
    }
})
